export default "__VITE_ASSET__DKvMcD1M__"